<template>
  <qx-custom-form @sub="getFormVal" :noSubBtn="true" ref="customForm" :formData="formData" />
</template>

<script>
export default {
  props: {
    trackType: {
      type: Number,
      default: -1,
    },
    orderId: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      formData: {
        form: [
          {
            label: '校准时间',
            value: 'verifyDate',
            type: 'date',
            width: '240px',
            attr: {
              type: 'datetime',
              time: '00:00:00',
            },
          },
          {
            label: '附件',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            attr: {
              limit: 1,
            },
            default: [],
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    setFormVal (data) {
      this.$refs.customForm.setVal('verifyDate', data.verifyDate || '');
      if (data.fileId && data.fileUrl) {
        this.$refs.customForm.setVal('file', [
          {
            id: data.fileId,
            url: data.fileUrl,
          },
        ]);
      }
    },
    resetFormVal () {
      this.$refs.customForm.setVal('verifyDate', '');
      this.$refs.customForm.setVal('file', []);
    },
    getFormVal () {
      const verifyDate = this.$refs.customForm.getVal('verifyDate');
      const file = this.$refs.customForm.getVal('file');
      let fileId = 0;
      let fileUrl = '';
      if (file && file.length) {
        fileId = file[0].id;
        fileUrl = file[0].storePath;
      }
      const formData = {
        orderId: this.orderId,
        trackType: this.trackType,
        verifyDate: this.formatDate(verifyDate, 1) || '',
        fileId,
        fileUrl,
      };
      return formData;
    },
  },
};
</script>

<style>
</style>
